module.exports = __webpack_public_path__ + "static/media/downred.669f155e.svg";